import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import Decimal from 'decimal.js';
import { TtOrderMetadata } from '@/lib/api/risk/brokerage/tt';
import { AttachCustomerForm } from './AttachCustomerForm';

interface OrderTextFields {
  textA?: string | null;
  textB?: string | null;
  textC?: string | null;
  textTT?: string | null;
}

interface AttachCustomerModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  guidOrderId: string;
  existingMetadata?: TtOrderMetadata | null;
  orderTextFields?: OrderTextFields;
  instrumentName?: string | null;
  totalQuantity?: Decimal | null;
  orderQuantity?: Decimal | null;
  remainingQuantity?: Decimal | null;
  filledQuantity?: Decimal | null;
}

export function AttachCustomerModal({
  open,
  onOpenChange,
  guidOrderId,
  existingMetadata,
  orderTextFields,
  instrumentName,
  totalQuantity,
  orderQuantity,
  remainingQuantity,
  filledQuantity,
}: AttachCustomerModalProps) {
  const handleSuccess = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px] md:max-w-[800px]">
        <DialogHeader>
          <DialogTitle>Attach Customer Info</DialogTitle>
        </DialogHeader>
        {open && (
          <AttachCustomerForm
            key={guidOrderId}
            guidOrderId={guidOrderId}
            existingMetadata={existingMetadata}
            onSuccess={handleSuccess}
            orderTextFields={orderTextFields}
            instrumentName={instrumentName}
            totalQuantity={totalQuantity}
            orderQuantity={orderQuantity}
            remainingQuantity={remainingQuantity}
            filledQuantity={filledQuantity}
            isModal
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
